// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teachingcenter-warp .page_header[data-v-02f70e88]{background-color:transparent!important;margin-bottom:12px}.teachingcenter-warp .list-warp[data-v-02f70e88]{display:flex;justify-content:space-between;flex-wrap:wrap}.teachingcenter-warp .list-warp[data-v-02f70e88]:after{content:\"\";width:294px}", ""]);
// Exports
module.exports = exports;
